import React, { KeyboardEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ResearchPost } from "../../types";
import type { ViewMode } from "../common/ViewToggle";

interface ResearchCardProps {
  post: ResearchPost;
  variant?: ViewMode;
}

const ResearchCard: React.FC<ResearchCardProps> = ({ post, variant = "grid" }) => {
  const navigate = useNavigate();
  const isList = variant === "list";

  const handleNavigate = () => {
    if (post.detailsLink && post.detailsLink !== "#") {
      navigate(post.detailsLink);
    }
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleNavigate();
    }
  };

  const imageBlock = (
    <div
      className="blog-card__image"
      style={
        isList
          ? {
              flex: "0 0 280px",
              minHeight: "200px",
              overflow: "hidden",
            }
          : undefined
      }
    >
      <img
        src={post.image}
        alt={post.imageAlt}
        style={isList ? { width: "100%", height: "100%", objectFit: "cover" } : undefined}
      />
      <div className="blog-card__overlay">
        <Link
          to={post.detailsLink}
          className="blog-card__link"
          onClick={(event) => event.stopPropagation()}
        >
          <i className="fas fa-arrow-right"></i>
        </Link>
      </div>
    </div>
  );

  const contentBlock = (
    <div
      className="blog-card__content"
      style={isList ? { flex: "1", padding: "1.25rem 1.5rem" } : undefined}
    >
      <h3 className="blog-card__title">
        <Link
          to={post.detailsLink}
          onClick={(event) => event.stopPropagation()}
        >
          {post.title}
        </Link>
      </h3>
      <p className="blog-card__excerpt">{post.excerpt}</p>
      {post.tags.length > 0 && (
        <div className="blog-card__tags mb-2">
          {post.tags.map((tag, index) => (
            <span key={index} className="tag">
              {tag}
            </span>
          ))}
        </div>
      )}
    </div>
  );

  const cardInner = (
    <div
      className={`blog-card ${isList ? "blog-card--list" : ""}`}
      role="button"
      tabIndex={0}
      onClick={handleNavigate}
      onKeyDown={handleKeyDown}
      style={
        isList
          ? {
              display: "flex",
              flexDirection: "row",
              alignItems: "stretch",
              overflow: "hidden",
              borderRadius: "12px",
              boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
            }
          : undefined
      }
    >
      {imageBlock}
      {contentBlock}
    </div>
  );

  if (isList) {
    return <div className="col-12 mb-4">{cardInner}</div>;
  }

  return <div className="col-xl-4 col-lg-4 col-md-6 mb-4">{cardInner}</div>;
};

export default ResearchCard;
